<div style="max-height: 700px;background: #161616;">
    <app-edit-property [injectedProject]="data.project" [injectedProperty]="data.property"
        (closeDialogAfterDeletion)="closeDialogAfterDeletion($event)"></app-edit-property>
</div>